export default __webpack_public_path__ + "static/media/36I-102713_-15710_0.b997819c.jpg";